<template>
  <div class="vsebina-postavitev odmik-vsebine" v-if="this.seznamClientId.length > 0">
    <div class="card-header">
      <h2>
        {{ instructions.t2api_client.naziv }}
      </h2>
      <p v-html="instructions.t2api_client.opis">
      </p>
      <br/>
      <p>
        <b>
          Provider URL:
        </b>
        {{ providerUrl }}
      </p>
      <p>
        <b>
          API URL:
        </b>
        {{ apiUrl }}
      </p>
      <p>
        <b>
          Trenutni access token:
        </b>
        {{ this.accessToken }}
      </p>
      <hr>
      <div v-if="clientDataList.length > 0">
        <h2>
          {{ instructions.client_splosno.naziv }}
        </h2>
        <br/>
        <p>
          {{ instructions.client_splosno.opis }}
        </p>
        <br/>
        <br/>
        <table>
          <tr>
            <th>
              Client Id
            </th>
            <th>
              Name
            </th>
            <th>
              Secret
            </th>
            <th>
              RedirectUrl
            </th>
          </tr>
          <tr v-for="(clientData) in clientDataList">
            <td>
              {{ clientData.clientId }}
            </td>
            <td>
              {{ clientData.name }}
            </td>
            <td>
              {{ clientData.secret }}
            </td>
            <td>
              {{ clientData.redirectUri }}
            </td>
          </tr>
        </table>
        <hr>
        <h2>
          {{ instructions.api.naziv }}
        </h2>
        <p v-html="instructions.api.opis">
        </p>
        <table>
          <tr>
            <th>
              Naziv
            </th>
            <th>
              Opis
            </th>
            <th>
              Klic
            </th>
          </tr>
          <tr v-for="(IzpisApiCalls) in APIklici">
            <td>
              {{ IzpisApiCalls.naziv }}
            </td>
            <td>
              {{ IzpisApiCalls.opis }}
            </td>
            <td>
              <a v-bind:href="apiUrl + IzpisApiCalls.klic + '&access_token=' + accessToken"
                 target="_blank">
                {{ IzpisApiCalls.klic }}
              </a>
            </td>
          </tr>
        </table>
        <hr>
        <h2>
          {{ instructions.provider.naziv }}
        </h2>
        <p v-html="instructions.provider.opis">
        </p>
        <table>
          <tr>
            <th>
              Naziv
            </th>
            <th>
              Opis
            </th>
            <th>
              Klic
            </th>
          </tr>
          <tr v-for="(IzpisproviderCalls, key) in providerCalls">
            <td>
              {{ IzpisproviderCalls.naziv }}
            </td>
            <td>
              {{ IzpisproviderCalls.opis }}
            </td>
            <td>
              <a v-bind:href="providerUrl + IzpisproviderCalls.klic" target="_blank">
                {{ IzpisproviderCalls.klic }}
              </a>
            </td>
          </tr>
        </table>
        <hr>
        <h2>
          {{ instructions.oauth_javascript.naziv }}
        </h2>
        <p v-html="instructions.oauth_javascript.opis">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {configSSO} from '../../../../assets/js/config.js'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {Input, Button, Table} from 'element-ui'
import Cookie from 'js-cookie'

export default {
  name: '',
  components: {
    [Input.name]: Input,
    [Button.name]: Button,
    [Table.name]: Table
  },
  data () {
    return {
      clientAgent: null,
      accessToken: '',
      clientDataListTemp: [],
      clientDataList: [],
      seznamClientId: [],
      seznamDovoljenj: [],
      instructions: [],
      redirectUri: '',
      providerUrl: '',
      apiUrl: '',
      APIklici: [],
      providerCalls: [],
      configSSO: '',
      confirm: false
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.accessToken = Cookie.get(configSSO.ACCESS_TOKEN_NAME)
    this.CheckPravice()
    this.KliciApijev()
    this.KliciProviderja()
    this.GetInstructions()
  },
  methods: {
    CheckPravice () {
      this.clientAgent.postWsRequest(this, 'permissions/all', [], null, 'ObravnavajPravice', '')
    },
    ObravnavajPravice (podatki) {
      this.seznamClientId = podatki.results.CLIENT_DATA.results
      if (this.seznamClientId.length > 0) {
        this.GetClientData()
      }
    },
    GetClientData () {
      this.clientDataList = []
      this.providerUrl = 'https://' + configSSO.AUTH0_DOMAIN
      this.apiUrl = process.env.WS_URL
      this.clientDataListTemp = []
      for (let i = 0; i < this.seznamClientId.length; i++) {
        let param = ['clientId=' + this.seznamClientId[i]]
        this.clientAgent.postWsRequest(this, 'base/getClientData', param, this.seznamClientId[i], 'DodajClientDataVSeznam', '')
      }
    },
    DodajClientDataVSeznam (podatki, prenosniParam) {
      podatki.clientId = prenosniParam
      this.clientDataListTemp.push(podatki)
      if (this.seznamClientId.length === this.clientDataListTemp.length) {
        for (let i = 0; i < this.seznamClientId.length; i++) {
          for (let j = 0; j < this.clientDataListTemp.length; j++) {
            if (this.clientDataListTemp[j].clientId === this.seznamClientId[i]) {
              this.clientDataList.push(this.clientDataListTemp[j])
              break
            }
          }
        }
      }
    },
    KliciApijev () {
      this.clientAgent.postWsRequest(this, 'base/getApiCalls', [], null, 'KliciApijevCallback', '')
    },
    KliciApijevCallback (podatki) {
      this.APIklici = podatki.data
      this.loading = false
    },
    KliciProviderja () {
      this.clientAgent.postWsRequest(this, 'base/getProviderCalls', [], null, 'KliciProviderjaCallback', '')
    },
    KliciProviderjaCallback (podatki) {
      this.providerCalls = podatki.data
      this.loading = false
    },
    GetInstructions () {
      this.instructions = []
      this.clientAgent.postWsRequest(this, 'base/getInstructions', [], null, 'GetInstructionsCallback', '')
    },
    GetInstructionsCallback (podatki) {
      this.instructions = podatki.data
    }
  }
}
</script>
<style scoped>
table td {
  margin: 12px 12px 12px 12px;
  padding: 12px 12px 12px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/ClientServise.vue